import React from 'react';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { ArrowRight, CheckCircle, Sparkles, Users, Brain } from 'lucide-react';
export const PilotClosed = () => {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-655">
      <main className="relative flex-grow overflow-hidden" data-id="element-656">
        {/* Background pattern */}
        <div className="absolute inset-0 bg-grid-gray-900/[0.02] -z-10" data-id="element-657" />

        {/* Background gradient blobs - Preserved and refined */}
        <div className="absolute -left-[300px] top-[10%] w-[1400px] h-[1400px] bg-gradient-to-tr from-cyan-500/10 via-primary-300/5 to-cyan-200/10 rounded-[50%_50%_45%_55%] blur-3xl -z-10" data-id="element-658" />
        <div className="absolute top-0 right-1/3 w-[900px] h-[900px] bg-gradient-to-br from-cyan-400/10 via-teal-400/5 to-blue-400/10 rounded-[60%_40%_55%_45%] blur-3xl -z-10" data-id="element-659" />
        <div className="absolute top-[30%] -left-[200px] w-[800px] h-[800px] bg-gradient-to-tr from-purple-400/10 via-violet-400/5 to-fuchsia-400/10 rounded-[40%_60%_45%_55%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-660" />
        <div className="absolute top-[60%] right-0 w-[750px] h-[750px] bg-gradient-to-bl from-amber-400/10 via-orange-400/5 to-red-400/10 rounded-[55%_45%_60%_40%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '1.5s'
      }} data-id="element-661" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 relative z-10" data-id="element-662">
          {/* Hero Section */}
          <div className="text-center mb-16 md:mb-20" data-id="element-663">
            <div className="inline-flex items-center justify-center px-4 py-1.5 mb-6 rounded-full bg-cyan-50 border border-cyan-100 text-cyan-700 text-sm font-medium" data-id="element-664">
              <Sparkles className="w-4 h-4 mr-2" data-id="element-665" />
              New Chapter
            </div>
            <h1 className="text-4xl md:text-6xl font-serif font-normal text-cyan-900 mb-6 tracking-tight" data-id="element-666">
              The pilot phase is complete
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-667">
              Nisa is now open to all instructional coaches.
            </p>
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-16" data-id="element-668">
            {/* Left Column: Thank You Message */}
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 md:p-10 shadow-sm border border-gray-100 flex flex-col justify-center h-full" data-id="element-669">
              <h2 className="text-2xl font-serif text-gray-900 mb-6" data-id="element-670">
                To our pilot cohort
              </h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-671">
                <p data-id="element-672">
                  Thank you to all the coaches who participated in our pilot
                  program. Your insights, feedback, and dedication have been
                  instrumental in shaping Nisa.
                </p>
                <p data-id="element-673">
                  Because of your contributions, we've built a tool that truly
                  understands the nuances of instructional coaching—making it
                  more intentional, less administrative, and deeply impactful.
                </p>
                <div className="pt-4 flex items-center text-primary-700 font-medium" data-id="element-674">
                  <Users className="w-5 h-5 mr-3" data-id="element-675" />
                  <span data-id="element-676">Built with coaches, for coaches</span>
                </div>
              </div>
            </div>

            {/* Right Column: Benefits/Features */}
            <div className="bg-gradient-to-br from-white/90 to-cyan-50/50 backdrop-blur-sm rounded-2xl p-8 md:p-10 shadow-sm border border-gray-100" data-id="element-677">
              <h2 className="text-2xl font-serif text-gray-900 mb-8" data-id="element-678">
                Why join Nisa today?
              </h2>
              <ul className="space-y-6" data-id="element-679">
                <li className="flex items-start" data-id="element-680">
                  <div className="flex-shrink-0 mt-1" data-id="element-681">
                    <div className="w-8 h-8 rounded-full bg-cyan-100 flex items-center justify-center" data-id="element-682">
                      <Brain className="w-4 h-4 text-cyan-700" data-id="element-683" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-684">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-685">
                      Intelligent Support
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-686">
                      AI tools that lighten your administrative workload so you
                      can focus on people, not paperwork.
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-687">
                  <div className="flex-shrink-0 mt-1" data-id="element-688">
                    <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center" data-id="element-689">
                      <Users className="w-4 h-4 text-purple-700" data-id="element-690" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-691">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-692">
                      Deeper Relationships
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-693">
                      Tools designed to strengthen the coach-teacher partnership
                      through consistent, high-quality support.
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-694">
                  <div className="flex-shrink-0 mt-1" data-id="element-695">
                    <div className="w-8 h-8 rounded-full bg-teal-100 flex items-center justify-center" data-id="element-696">
                      <CheckCircle className="w-4 h-4 text-teal-700" data-id="element-697" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-698">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-699">
                      Immediate Access
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-700">
                      No waitlists. Create your account and start using Nisa
                      with your teachers today.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-primary-900 rounded-2xl p-8 md:p-12 shadow-xl text-center relative overflow-hidden" data-id="element-701">
            {/* Decorative background elements for CTA */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-702" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-703" />

            <div className="relative z-10 max-w-3xl mx-auto" data-id="element-704">
              <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-705">
                Ready to transform your coaching practice?
              </h2>
              <p className="text-lg text-cyan-100 mb-8 max-w-2xl mx-auto" data-id="element-706">
                Join the community of instructional coaches using Nisa to make
                their day-to-day work more impactful.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-707">
                <a href="http://app.nisa.coach" data-id="element-708">
                  <Button size="lg" className="bg-white text-primary-900 hover:bg-cyan-50 border-transparent w-full sm:w-auto" data-id="element-709">
                    Create a coach account
                    <ArrowRight className="w-5 h-5 ml-2" data-id="element-710" />
                  </Button>
                </a>
                <a href="https://app.nisa.coach/" data-id="element-711">
                  <Button variant="outline" size="lg" className="border-cyan-700 text-cyan-100 hover:bg-primary-800 hover:text-white hover:border-cyan-500 w-full sm:w-auto" data-id="element-712">
                    Log in to existing account
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-713" />
    </div>;
};